import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography, TextField, Avatar, Button,  } from "@mui/material";
import { useHistory, useLocation } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

const GovPostCommentsReplyPage = () => {
    const [comment, setComment] = useState(null);
    const history = useHistory();
    const [replyText, setReplyText] = useState("");
    const [replyChain, setReplyChain] = useState([]);

    const { id, commentId } = useParams();

    const [govPost, setGovPost] = useState(null);

    useEffect(() => {
        axios.get(`/govPost/${id}`)
            .then(res => setGovPost(res.data))
            .catch(err => console.error("Error loading bill", err));
    }, [id]);

    /*useEffect(() => {
        const fetchContext = async () => {
            try {
            const res = await axios.get(
                `/govPost/${id}/commentContext/${commentId}`
            );
            setReplyChain(res.data.chain);
            setComment(res.data.current);
            } catch (err) {
            console.error("Error loading comment context", err);
            }
        };

        fetchContext();
    }, [id, commentId]);*/
    const location = useLocation();
const source = location.state?.source;


const [isLoadingReplies, setIsLoadingReplies] = useState(false);


// Pagination stored in refs — never captured stale in observer closures
const cursorRef = useRef(null);
const hasMoreRef = useRef(true);
const isFetchingRef = useRef(false);
const abortRef = useRef(null);


// ── Stable navigation callbacks — safe to pass to React.memo children ──────
const handleNavigate = useCallback((targetId) => {
 history.push(`/govPost/${id}/comments/${targetId}`, { source });
}, [history, id, source]);


// ── Core fetch — reads cursor from ref, never from a stale closure ─────────
 const fetchReplies = useCallback(async (overrideCursor) => {
   if (isFetchingRef.current || !hasMoreRef.current) return;


   abortRef.current?.abort();
   abortRef.current = new AbortController();
   isFetchingRef.current = true;
   setIsLoadingReplies(true);


   // undefined means "use whatever cursorRef holds right now"
   const cursorToUse = overrideCursor !== undefined ? overrideCursor : cursorRef.current;


   try {
     const res = await axios.get(
       `/govPost/${id}/commentContext/${commentId}`,
       {
         params: { cursor: cursorToUse ?? undefined, limit: 10 },
         signal: abortRef.current.signal,
       }
     );


     if (!cursorToUse) {
       // Initial load
       setReplyChain(res.data.chain);
       setComment(res.data.current);
     } else {
       // Append page
       setComment(prev => prev
         ? { ...prev, replies: [...prev.replies, ...res.data.current.replies] }
         : prev
       );
     }


     // Write to refs synchronously — observer always reads current values
     cursorRef.current = res.data.nextCursor;
     hasMoreRef.current = res.data.hasMore;


   } catch (err) {
     if (axios.isCancel(err) || err.name === "CanceledError") return;
     console.error("Fetch replies failed", err);
   } finally {
     isFetchingRef.current = false;
     setIsLoadingReplies(false);
   }
 }, [id, commentId]);


 // ── Reset + initial load whenever route params change ─────────────────────
 useEffect(() => {
   cursorRef.current = null;
   hasMoreRef.current = true;
   isFetchingRef.current = false;
   setComment(null);
   setReplyChain([]);
   fetchReplies(null);
   return () => abortRef.current?.abort();
 }, [id, commentId, fetchReplies]);


 // ── IntersectionObserver on a SEPARATE sentinel div, not the last card ─────
 // This is what makes click + observer mutually exclusive at the DOM level.
 const observerRef = useRef();
 const sentinelRef = useCallback(node => {
   if (observerRef.current) observerRef.current.disconnect();
   if (!node) return;
   observerRef.current = new IntersectionObserver(entries => {
     if (entries[0].isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
       fetchReplies(undefined); // reads cursorRef.current internally
     }
   }, { rootMargin: "300px" });
   observerRef.current.observe(node);
 }, [fetchReplies]);


    const CommentCard = ({ comment }) => (
        <Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            //onClick={() => history.push(`/govPost/${id}/comments/${comment._id}`)} 
            onClick={() => handleNavigate(comment._id)}
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
                cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
            }}
        >
            <Box display="flex" alignItems="flex-start" gap={1}>
            <Avatar
                src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
            />
            <Box>
                <Typography variant="subtitle1" fontWeight="bold"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "inline-block",
                                            "&:hover": {
                                            textDecoration: "underline",
                                            textDecorationColor: "currentColor", 
                                            textUnderlineOffset: "3px",
                                            },
                                        }}
                >
                {comment.author?.first_name} {comment.author?.last_name}
                </Typography>
                <Typography variant="body2" color="text.secondary"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "block",
                                            "&:hover": {
                                            textDecoration: "underline",
                                            textDecorationColor: "#currentColor",
                                            textUnderlineOffset: "3px",
                                            },
                                        }}
                >
                @{comment.author?.username}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                {comment.text}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                                {`${new Date(comment.created_at).toLocaleString()}, ${
                                                    comment.replyCount ?? 0
                                                } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                            </Typography>
            </Box>
            </Box>

            <Box mt={2} display="flex" alignItems="center" gap={1}>
                                {comment.replyVoted ? (
                                    <Box
                                    sx={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        "&:hover .voted-btn": {
                                            opacity: 0,
                                        },
                                        "&:hover .undo-btn": {
                                            opacity: 1,
                                            pointerEvents: "auto",
                                        },
                                    }}
                                >
                                        <Button
                                            size="small"
                                            className="voted-btn"
                                            variant="contained"
                                            color="success"
                                            disabled
                                            sx={{
                                            transition: "opacity 0.2s ease",
                                            }}
                                        >
                                        Power Voted
                                    </Button>
                                    <Button
                                            size="small"
                                            className="undo-btn"
                                            variant="contained"
                                            color="error"
                                            sx={{
                                            inset: 0,
                                            position: "absolute",
                                            transition: "opacity 0.2s ease",
                                            opacity: 0,
                                            pointerEvents: "none",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleReplyVote(comment._id)
                                        }}
                                    >
                                            Undo
                                    </Button>
                                </Box>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)}
                                    }
                                    >
                                        ▲ Power Vote
                                    </Button>
                                )}
                                <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                        </Box>
        </Box>
    );

    const handleReplySubmit = async () => {
        if (!replyText.trim()) return;

        try {
            const res = await axios.post(`/govPostComments/${comment._id}/reply`, {
                text: replyText,
            });

            const commentRes = await axios.get(
                `/govPost/${id}/commentContext/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);
            setReplyText("");
        } catch (err) {
            console.error("Reply error", err);
        }
    };

    const toggleVote = async (postId) => {
        try {
            const res = await axios.post(`/govPost/${postId}/upvote`);
            const { upvotes, voted } = res.data;

            setGovPost(prevCase => ({
                ...prevCase,
                upvotes,
                voted
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

    const updateReplyChainRecursive = (nodes = [], id, updates) => {
        let changed = false;

        const next = nodes.map((n) => {
        if (n._id === id) {
            changed = true;
            return { ...n, ...updates };
        }

        const updatedReplies = updateReplyChainRecursive(n.replies, id, updates);
        if (updatedReplies !== n.replies) {
            changed = true;
            return { ...n, replies: updatedReplies };
        }

        return n;
        });

        return changed ? next : nodes;
    };

    const updateReplyRecursive = (replies = [], replyId, updates) => {
        return replies.map((r) => {
        if (r._id === replyId) {
            return { ...r, ...updates };
        }

        return {
            ...r,
            replies: updateReplyRecursive(r.replies, replyId, updates),
        };
        });
    };

    const toggleReplyVote = async (replyId) => {
        try {
        const res = await axios.post(
            `/govPost/${id}/commentReplies/${replyId}/upvote`
        );

        const { replyUpvotes, replyVoted } = res.data;

        setComment((prev) => {
            if (!prev) return prev;

            // Case A: current focused comment is the reply
            if (prev._id === replyId) {
            return {
                ...prev,
                replyUpvotes,
                replyVoted,
            };
            }

            // Case B: reply exists somewhere in the chain
            return {
            ...prev,
            replies: updateReplyRecursive(prev.replies, replyId, {
                replyUpvotes,
                replyVoted,
            }),
            };
        });

        setReplyChain((prev) =>
            updateReplyChainRecursive(prev, replyId, {
            replyUpvotes,
            replyVoted,
            })
        );
        } catch (err) {
        console.error("Reply vote error", err);
        }
    };

    if (!comment) return <Typography>Loading...</Typography>;

    const visitProfile = (e, userId) => {
            e.stopPropagation(); // prevent opening the post
            history.push(`/user/view/${userId}`);
        };

    if (!govPost) {
        return <div>Loading...</div>; 
    }

    const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: ["/page2/b"]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: ["/Government/StateBills"]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    //const location = useLocation();
    const modeFromState = location.state?.mode;
    /*
    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };*/
    const isActive = (item) => {
        // If we came from a mode, ONLY use that
        if (modeFromState) {
            return (
                (modeFromState === "popular" && item.label === "Popular Opinion") ||
                (modeFromState === "following" && item.label === "Following")
            );
        }

        // Otherwise fallback
        return item.matchPaths?.some((match) =>
            location.pathname.startsWith(match)
        );
    };

    const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
                borderColor: "black",
                color: "black",
                backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
    return (
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
            </Box>*/}
            <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
    <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                onClick={() => history.push(`/govPost/${govPost._id}/comments`)}
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                }}
        >
            {/** Root Post */}
            <Box display="flex" alignItems="flex-start" gap={1}>
                        <Avatar
                            src={govPost.author?.profileImageUrl || '/default-avatar.jpg'}
                            alt={`${govPost.author?.first_name || ''} ${govPost.author?.last_name || ''}`}
                            onClick={(e) => visitProfile(e, govPost.author?._id)}
                            sx={{ 
                                width: 62, 
                                height: 62,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "#d9e4f0",
                                }, 
                                }}
                        />
                        <Box>
                            <Typography variant="subtitle1" fontWeight="bold"
                            onClick={(e) => visitProfile(e, govPost.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                            >
                            {govPost.author?.first_name && govPost.author?.last_name
                                ? `${govPost.author.first_name} ${govPost.author.last_name}`
                                : 'Unknown Name'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary"
                            onClick={(e) => visitProfile(e, govPost.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                            >
                            @{govPost.author?.username || 'unknown'}
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                {govPost.content}
                            </Typography>
                
                            <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                >
                                    {`${new Date(govPost.created_at).toLocaleString()}, ${
                                        govPost.commentCount
                                    } ${govPost.commentCount === 1 ? 'reply' : 'replies'}`}
                                </Typography>
                        </Box>
                    </Box>
    
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {govPost.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleVote(govPost._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleVote(govPost._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{govPost.upvotes} Power Votes</Typography>
                    </Box>
                    </Box>
            {/* Reply chain */}
            {replyChain.map((c) => (
            <CommentCard
                key={c._id}
                comment={c}
            />
            ))}
    <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                }}
        >
        {/* original comment */}
        <Box display="flex" alignItems="flex-start" gap={1}>
        <Avatar
            src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
            onClick={(e) => visitProfile(e, comment.author?._id)}
                            sx={{ 
                                width: 62, 
                                height: 62,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "#d9e4f0",
                                }, 
                                }}
        />
        <Box>
            <Typography variant="subtitle1" fontWeight="bold"
            onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
            >
            {comment.author?.first_name} {comment.author?.last_name}
            </Typography>
            <Typography variant="body2" color="text.secondary"
            onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
            >
            @{comment.author?.username}
            </Typography>
            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
            {comment.text}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
            {`${new Date(comment.created_at).toLocaleString()}, ${
                comment.replyCount
            } ${comment.replyCount === 1 ? "reply" : "replies"}`}
            </Typography>
        </Box>
        </Box>

        <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.replyVoted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleReplyVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                    </Box>
    </Box>
    {/* Comment Form */}
        <Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
            }}
        >
        <TextField
            fullWidth
            multiline
            rows={2}
            placeholder="Engage in intellectual discourse..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
        />
        <Button
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={(e) => {
            e.stopPropagation();
            handleReplySubmit();
            }}
        >
            Reply
        </Button>
        </Box>
        {/* replies */}
        {comment.replies.length != 0 || hasMoreRef.current ? (
            comment.replies.map((reply, i) => {
                const isLast = i === comment.replies.length - 1;
            return (
            <Box
                p={2} // padding inside box
                key={reply._id}
                ref={isLast ? sentinelRef : null}
                onClick={() => handleNavigate(reply._id)}
                //onClick={() => history.push(`/govPost/${id}/comments/${reply._id}`, { mode: modeFromState })}
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
                }}
        >
            <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                                src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                                alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
                            />
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                >
                                {reply.author?.first_name && reply.author?.last_name
                                    ? `${reply.author.first_name} ${reply.author.last_name}`
                                    : 'Unknown Name'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                >
                                @{reply.author?.username || 'unknown'}
                                </Typography>

                                {/* Post content */}
                                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                    {reply.text}
                                </Typography>

                                {/* Date */}
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                >
                                    {`${new Date(reply.created_at).toLocaleString()}, ${
                                    reply.replyCount ?? 0
                                    } ${reply.replyCount === 1 ? "reply" : "replies"}`}
                                </Typography>

                            </Box>
                        </Box>
                
                <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {reply.replyVoted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(reply._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleReplyVote(reply._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{reply.replyUpvotes} Power Votes</Typography>
                    </Box>
            </Box>
            )})
        ) : (
            <Typography></Typography>
        )}
    </div>
    );
};

export default GovPostCommentsReplyPage;